import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=59c09c1f"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=59c09c1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports